import React from 'react'
import Link from 'gatsby-link'

import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";

import image1 from '../../layouts/images/project1/image1.jpg'
import image2 from '../../layouts/images/project1/image2.jpg'
import image3 from '../../layouts/images/project1/image3.jpg'
import image4 from '../../layouts/images/project1/image4.jpg'
import image5 from '../../layouts/images/project1/image12.jpg'
import image6 from '../../layouts/images/project1/image10.jpg'
import image7 from '../../layouts/images/project1/image11.jpg'

const AgeFriendlyCommunitiesPage = () => (
    <div className="container">
        <div className="row">
            <div className="col-lg-5 project-info">
                <h3>Age Friendly Communities</h3>
                <div className="project-content">
                    <p>By 2021 it is estimated that more than 25% of Victoria’s population will be over 60. In some regional areas it is estimated to reach almost 50%.</p>
                    <p>Council on the Ageing (COTA) Victoria and two Melbourne artists are facing these developments with the creative approach of storytelling, one of the oldest art forms and ways of sharing experience. Throughout history older people have been humanity’s consummate storytellers. COTA Victoria, the peak body for older people in Victoria, provides a platform for them to tell their unique stories, to participate and belong to a community that strives to be respectful and age-friendly. But what does being age-friendly even mean? By listening to stories of older people we will find out what they understand of an age-friendly world.</p>
                    <p>As Event Coordinator and Research Volunteer, I am responsible for organising COTA’s first interactive art exhibition about growing older in the community and the meaning of age-friendliness. Participative observations and narrative analysis will help to understand what the concept of age-friendliness for senior’s means as well as how and where age-friendly interventions can happen.</p>
                    <p>A further analysis of the story material will be indicated on the COTA Victoria Website.</p>
                </div>
            </div>

            <div className="col-lg-7">

                <div className="slider">
                    <ImageGallery
                        showThumbnails={false}
                        showFullscreenButton={false}
                        autoPlay={true}
                        items={[
                            { original: image1, },
                            { original: image2, },
                            { original: image3, },
                            { original: image4, },
                            { original: image5, },
                            { original: image6, },
                            { original: image7, }
                        ]} />
                </div>

                <br />
                <br />

                <p className="project-blurb">The Art of Storytelling and what it means to grow older in the community.</p>

                <ul className="tags">
                    <li>Age-friendliness</li>
                    <li>Communities</li>
                    <li>Storytelling</li>
                    <li>Narrative Analysis</li>
                    <li>Participative Observation</li>
                    <li>Art</li>
                    <li>Exhibition</li>
                    <li>Creative Workshops</li>
                </ul>

                <div className="footer-info">
                    <p><div className="highlight">Cooperation Partner:</div> Council on the Ageing (COTA) Victoria, Arts Access Victoria (AAV), Suzanne Nguyen</p>
                    <p><div className="highlight">Source:</div> Observations and Narratives</p>
                    <p><div className="highlight">Date:</div> April 2014</p>
                </div>

            </div>
        </div>
    </div>
)

export default AgeFriendlyCommunitiesPage



// WEBPACK FOOTER //
// ./src/pages/projects/age-friendly-communities.js